import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
// import 'rxjs/add/observable/fromEvent';
// import 'rxjs/add/observable/merge';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
import { filter, debounceTime } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserIdleService implements OnDestroy {
  private idleTimeout: any;
  private idleTime: number = 1200000; // Tiempo de inactividad en ms para cierre
  idleEvent: Subject<boolean> = new Subject();
  private userActivityEvents: Subscription;
  private storageEventSubscription: Subscription;

  constructor(private router: Router, private ngZone: NgZone, private loginService: LoginService,) {
    
      this.startWatching();

      // Escuchar eventos de navegación
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.resetTimer();
      });

      this.monitorUserActivity();

      // Escuchar eventos de almacenamiento para sincronizar entre pestañas con debounceTime
      const storageObservable = fromEvent<StorageEvent>(window, 'storage').pipe(
        debounceTime(1000) // Ajusta el tiempo de debounce según sea necesario
      );

      this.storageEventSubscription = storageObservable.subscribe((event: StorageEvent) => {
        if (event.key === 'idleEvent' && event.newValue === 'true') {
          this.onIdle();
        } else if (event.key === 'lastAction') {
          var timeBetweenEvent = JSON.parse(event.newValue) - JSON.parse(event.oldValue);
          
          if(timeBetweenEvent > 20000)
            this.resetTimer();
        }
      });

  }

  ngOnDestroy() {
    if (this.userActivityEvents) {
      this.userActivityEvents.unsubscribe();
    }
    if (this.storageEventSubscription) {
      this.storageEventSubscription.unsubscribe();
    }
  }

  startWatching() {
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.idleTimeout);
    if(this.loginService.isEmployeeUser())
    {
      this.idleTimeout = setTimeout(() => this.triggerIdleEvent(), this.idleTime);

      // Actualizar el tiempo de la última acción en localStorage
      localStorage.setItem('lastAction', Date.now().toString());
    }
  }

  triggerIdleEvent() {
    localStorage.setItem('idleEvent', 'true');
    this.onIdle();
  }

  onIdle() {
    this.idleEvent.next(true);
  }

  monitorUserActivity() {
    const mouseMove$ = fromEvent(document, 'mousemove');
    const keyDown$ = fromEvent(document, 'keydown');
    // const click$ = fromEvent(document, 'click');
    const userActivity$ = merge(mouseMove$, keyDown$);//, click$

    this.userActivityEvents = userActivity$.pipe(
      debounceTime(20000) // Ignorar eventos que ocurren en rápida sucesión
    ).subscribe(() => {
      this.resetTimer();
    });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/user-idle/user-idle.service.ts